// extracted by mini-css-extract-plugin
module.exports = {"image":"CompanyWorkflow_image__VaGIC","enterpriseItem":"CompanyWorkflow_enterpriseItem__BpzR2","whiteText":"CompanyWorkflow_whiteText__ZVq7B"};